"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// JSON CONFIG _______________________________________________________
//
//
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row,
      loadData = _ref.loadData,
      extraData = _ref.extraData;
    var questProjectList = row['targetedGroups.questprojectList'];
    var isGlobalAdmin = row['pawn.pawnId'] === row['globalAdminCheck.pawnId'];
    var questProjectCount = extraData['groups.questprojectCount'];
    var isQuestAdminRole = settings.type === 'questprojectadmin';
    if (isGlobalAdmin || questProjectList.length === questProjectCount && !isQuestAdminRole) {
      return /*#__PURE__*/_react["default"].createElement("div", null, "All");
    }
    if (questProjectList.length > 0) {
      var projectNames = questProjectList.map(function (item) {
        return item.group.label;
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("ul", {
          style: {
            padding: '0.5em 0 0.5em 0',
            margin: '0'
          }
        }, projectNames.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("li", null, "\u2022 ", item);
        }))
      }, questProjectList.length));
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, "None");
  };
};